export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_06.5d0061cd.jpg";